import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const exceptionsService = {
  getExceptions: function (options) {
    return api.get(`/Exceptions`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },

  deleteExceptions: function (options) {
    return api.delete(`/Exceptions`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default exceptionsService;
